import type { SkillGroup } from "../../types/skill";

interface SkillColumnProps {
  group: SkillGroup;
}

function SkillColumn({ group }: SkillColumnProps) {
  return (
    <div className="skill-group">
      <h3>{group.title}</h3>
      <div className="skill-list">
        {group.skills.map((skill) => (
          <div className="skill-pill" key={skill}>
            {skill}
          </div>
        ))}
      </div>
    </div>
  );
}

export default SkillColumn;
